exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form-container[data-v-fc136b8e] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  gap: 10px;\n}\n.charging-type-options[data-v-fc136b8e]  .vs__dropdown-menu {\n  height: 200px;\n}\n.description[data-v-fc136b8e] {\n  font-size: 14px;\n  color: #3c4858;\n}\n", ""]);

// exports
